import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CalAngularService } from '@cvx/cal-angular';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  private readonly _destroying$ = new Subject<void>();
  
  constructor(
    private router: Router,
    private calService: CalAngularService
  ) { }

  ngOnInit(): void {
    this.calService.isUserSignedIn()
      .pipe(takeUntil(this._destroying$))
      .subscribe((isSignedIn) => {
        if (isSignedIn) {
          this.router.navigate(['']);
        }
      });
  }

  login(): void {
    this.calService.userInitiatedSignIn().subscribe({
      next: () => {
        this.router.navigate(['']);
      },
      error: (error) => {
        console.error('Login failed:', error);
      }
    });
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
